export const SET_OPERATE_STATUS = 'SET_OPERATE_STATUS';
export const VISIBLE_CHANGE = 'VISIBLE_CHANGE';

/**
 * 设置菜单项的操作(禁用)状态
 * 
 * @param {any} data 
 * @returns 
 */
const setOperate = (data) => {
    return {
        type: SET_OPERATE_STATUS,
        payload: { operate: data }
    };
};

/**
 * 显示状态发生改变
 * 
 * @param {any} type 
 * @param {any} visible 
 * @returns 
 */
const visibleChange = (type, visible) => {
    return {
        type: SET_OPERATE_STATUS,
        payload: {
            [type]: visible
        }
    };
};

export default {
    setOperate,
    visibleChange
};